<template>
  <div class="page">
    <div class="result">
      <img :src="resultBackground" class="img-fluid" />

      <div class="result__info">
        <router-link :to="{ name: 'LiffProjAbbottAndLotteryEarnCount', query: { event_code: $route.query.from } }">
          <img src="./images/result-btn.png" class="img-fluid" />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import redeemApi from "@/apis/liff/v2/redeem";

export default {
  data() {
    return {
      event: null,
    }
  },
  computed: {
    resultBackground() {
      return this.event?.config?.result_background || require("./images/result-bg.jpg");
    },
  },
  async mounted() {
    const response = await redeemApi.getRedeemEvent({
      event_code: this.$route.query.event_code,
    });
    this.event = response.data.data.event;
  }
}
</script>

<style lang="scss" scoped>
.result {
  position: relative;

  &__info {
    position: absolute;
    bottom: 2%;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
  }
}
</style>
